import type { TOC } from '@ember/component/template-only'
import { or } from 'ember-truth-helpers'
import { on } from '@ember/modifier'

import { LayoutBlocksModal } from 'teacher-ui-client/components/layout-blocks/modal'
import { UiButton } from 'teacher-ui-client/components/ui-button'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { FidgetLoadingIndicatorComponent } from '@blakeelearning/fidget/components/fidget/loading-indicator'

interface Args {
  cancel: () => void
  confirm: () => void
  showModal?: boolean
  title: string
  cancelButtonText?: string
  confirmButtonText?: string
  allowCancelDuringSubmission?: boolean
  isSubmitting?: boolean
  confirmButtonAppearance?: ButtonAppearance
}
interface Signature {
  Element: Element
  Blocks: {
    default: []
  }
  Args: Args
}

export const LayoutBlocksConfirmModal: TOC<Signature> = <template>
  <LayoutBlocksModal @close={{@cancel}} @showModal={{@showModal}} @title={{@title}} ...attributes>
    <div class="p-4">
      {{yield}}
    </div>
    <div class="border-dusty-black-50 border-t p-2 text-right">
      {{#if @cancelButtonText}}
        <UiButton
          data-test-cancel
          class="min-w-32"
          disabled={{unless @allowCancelDuringSubmission @isSubmitting}}
          @appearance={{ButtonAppearance.muted}}
          {{on "click" @cancel}}
        >
          {{@cancelButtonText}}
        </UiButton>
      {{/if}}
      {{#if @confirmButtonText}}
        <UiButton
          data-test-submit
          class="relative ml-2 min-w-32"
          disabled={{@isSubmitting}}
          @appearance={{or @confirmButtonAppearance ButtonAppearance.regular}}
          {{on "click" @confirm}}
        >
          {{! Invisible text with absolute spinner ensures button width stays the same for both states }}
          <FidgetLoadingIndicatorComponent
            @show={{@isSubmitting}}
            @centered={{false}}
            @appearance="small"
            @overlay={{false}}
            class={{if @isSubmitting "absolute left-1/2 -translate-x-1/2 transform"}}
          />
          <span class={{if @isSubmitting "invisible"}}>
            {{@confirmButtonText}}
          </span>
        </UiButton>
      {{/if}}
    </div>
  </LayoutBlocksModal>
</template>

export default LayoutBlocksConfirmModal
